export const MOBILE_VIEW = 480;
export const DESKTOP_VIEW = 1280;

export const MOBILE = 'mobile';
export const DESKTOP = 'desktop';
